import { render, staticRenderFns } from "./PayfipRedirectionAfterPayment.vue?vue&type=template&id=1aeab994&"
import script from "./PayfipRedirectionAfterPayment.vue?vue&type=script&lang=js&"
export * from "./PayfipRedirectionAfterPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports